import React from 'react';
import { useIntl } from 'react-intl';

import { Actions } from '~/eds/src/components/Actions/Actions';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { Feedback } from '~/eds/src/modules/Feedback/Feedback';
import { Nullable } from '~/eds/src/types/Nullable';
import { UserAction } from '~/eds/src/types/UserAction';

import { MESSAGE_ACTIONS_CLASSNAME } from '../../chat/constants';
import { Message as MessageType } from '../../types/chat';

const workflowMessageStyles = {
  actions: {
    visibility: 'hidden',
  },
};

interface WorkflowMessageActionsProps {
  shouldShowActions: boolean;
  messageActions: UserAction[];
  message: MessageType;
  onSubmitFeedback: (value: Nullable<boolean>, comment?: string) => void;
}

export const WorkflowMessageActions = ({
  shouldShowActions,
  messageActions,
  message,
  onSubmitFeedback,
}: WorkflowMessageActionsProps) => {
  const intl = useIntl();

  if (!shouldShowActions) {
    return null;
  }

  return (
    <Layout
      alignSelf="flex-end"
      bg="background"
      borderRadius={4}
      className={MESSAGE_ACTIONS_CLASSNAME}
      styles={workflowMessageStyles.actions}
    >
      {messageActions.length > 0 && <Actions actions={messageActions} />}
      <Feedback
        value={message?.feedbackDetails?.value ?? null}
        onChange={onSubmitFeedback}
        variant="subtle"
        placeholders={{
          like: intl.formatMessage({
            id: 'WorkflowRoutingAgent.whatWorkedWellPlaceholder',
            defaultMessage:
              'What made this response helpful? Specific examples help us improve.',
            description:
              'Placeholder for feedback comment textarea when user liked the workflow routing message',
          }),
          dislike: intl.formatMessage({
            id: 'WorkflowRoutingAgent.whatCouldImprovePlaceholder',
            defaultMessage:
              'What would have made this better? Examples: "Wrong workflows suggested" or "Missing relevant workflow".',
            description:
              'Placeholder for feedback comment textarea when user disliked the workflow routing message',
          }),
        }}
        submitDetails={{
          onSubmit: (submitDetails) => {
            onSubmitFeedback(submitDetails.value, submitDetails.comment);
          },
          minLength: 20,
        }}
      />
    </Layout>
  );
};
